import {
	LOGIN,
	LOGIN_FAILURE,
	LOGIN_GET_SCHOOLS,
	LOGIN_GET_SCHOOLS_FAILURE,
	LOGIN_GET_SCHOOLS_SUCCESS,
	LOGIN_SUCCESS
} from "./actions";
import {debug} from "../../utility/functions";

export const dispatchOnLogin = () => dispatch => {
	dispatch({type: LOGIN})
};

export const dispatchOnLoginSuccess = () => dispatch => {
	dispatch({type: LOGIN_SUCCESS})
};

export const dispatchOnLoginFailure = () => dispatch => {
	dispatch({type: LOGIN_FAILURE})
};

export const dispatchOnLoginGetSchools = () => dispatch => {
	dispatch({type: LOGIN_GET_SCHOOLS})
};

export const dispatchOnLoginGetSchoolsSuccess = (response) => dispatch => {
	dispatch({
		type: LOGIN_GET_SCHOOLS_SUCCESS,
		schools: response.data,
	})
};

export const dispatchOnLoginGetSchoolsFailure = () => dispatch => {
	dispatch({type: LOGIN_GET_SCHOOLS_FAILURE})
};